import React from "react";
import Header from "components/Headers/Header";
import brand1 from "../../assets/img/custom/BrandAmbassador1.jpg";
import brand2 from "../../assets/img/custom/BrandAmbassador2.jpg";
import { Card, Col, Container, Row } from "reactstrap";

const BrandAmbassador = () => {
  return (
    <>
      <Header />
      <Container fluid>
        {" "}
        <Card className="p-3">
          <div className="w-100 overflow-hidden">
            <Row className="text-center justify-content-center p-3">
              <Col lg="6">
                <img src={brand1} alt="" width="100%" />
              </Col>
              <Col lg="6">
                <img src={brand2} alt="" width="100%" />
              </Col>
            </Row>
          </div>
        </Card>
      </Container>
    </>
  );
};

export default BrandAmbassador;
